import axios from "axios";
import firebase from "firebase";

const productsApiService = {
  async get() {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = "/api/products";

    return new Promise((resolve, reject) => {
      axios
        .get(endpoint, { headers: { Authorization: userIdToken } })
        .then((data) => resolve(data.data))
        .catch((reason) =>
          reject(new Error("Products API Error. " + reason.message))
        );
    });
  },
};

export default productsApiService;
